<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.62" height="17.972" viewBox="0 0 21.62 17.972">
    <g transform="translate(-389.19 -391.514)">
      <g>
        <path
          d="M400.116,403.7a4.836,4.836,0,0,1-4.1-7.372,21.819,21.819,0,0,1,4.077-4.515l.36-.3.323.339c.138.145,3.408,3.582,4.137,5.237a5.245,5.245,0,0,1-.579,4.514,4.492,4.492,0,0,1-3.912,2.087C400.322,403.7,400.219,403.7,400.116,403.7Zm.264-10.813a20.8,20.8,0,0,0-3.52,3.984,3.836,3.836,0,0,0,3.526,5.82,3.547,3.547,0,0,0,3.11-1.627,4.3,4.3,0,0,0,.505-3.572A26.6,26.6,0,0,0,400.38,392.888Z"
          fill="#777"
        />
        <path
          d="M400.453,406.061a12.129,12.129,0,0,1-5.375-1.25c-3.033-1.294-4.676-5.411-4.744-5.585l.931-.366c.015.039,1.561,3.9,4.231,5.042a11.185,11.185,0,0,0,8.609.542c3.117-1.079,5.534-5.59,5.557-5.635l.885.467c-.106.2-2.624,4.9-6.113,6.113A12.073,12.073,0,0,1,400.453,406.061Z"
          fill="#777"
        />
        <path
          d="M390.174,402.083l-.968-.254,1.013-3.864,3.46,1.145-.313.949-2.45-.81Z"
          fill="#777"
        />
        <path
          d="M410.81,409.486H389.19v-4.409h21.62Zm-20.62-1h19.62v-2.409H390.19Z"
          fill="#777"
        />
        <rect
          width="3.272"
          height="1"
          transform="matrix(0.25, -0.968, 0.968, 0.25, 391.567, 408.62)"
          fill="#777"
        />
        <rect
          width="3.272"
          height="1"
          transform="matrix(0.25, -0.968, 0.968, 0.25, 394.567, 408.62)"
          fill="#777"
        />
        <rect
          width="3.272"
          height="1"
          transform="matrix(0.25, -0.968, 0.968, 0.25, 397.567, 408.62)"
          fill="#777"
        />
        <rect
          width="3.272"
          height="1"
          transform="translate(400.567 408.62) rotate(-75.523)"
          fill="#777"
        />
        <rect
          width="3.272"
          height="1"
          transform="matrix(0.25, -0.968, 0.968, 0.25, 403.567, 408.62)"
          fill="#777"
        />
        <rect
          width="3.272"
          height="1"
          transform="matrix(0.25, -0.968, 0.968, 0.25, 406.567, 408.62)"
          fill="#777"
        />
      </g>
    </g>
  </svg>
</template>
